import { css } from '@emotion/react';
import { tokens } from '../tokens';
export function headerStyle({ alignCenter, mode }) {
    return css({
        padding: mode === 'decorative'
            ? `38px ${tokens.spacing.large} ${tokens.spacing.medium}`
            : `${tokens.spacing.large} 48px ${tokens.spacing.medium}
          ${alignCenter ? '48px' : tokens.spacing.large}`,
    });
}
export const bodyStaticStyle = css({
    paddingLeft: tokens.spacing.large,
    paddingRight: tokens.spacing.large,
});
export const footerStaticStyle = css({
    padding: `${tokens.spacing.medium} ${tokens.spacing.large}
    ${tokens.spacing.large} ${tokens.spacing.large}`,
});
